import * as React from 'react';

function SvgNeutralEmoji(props) {
  return (
    <svg viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M16.706 11.059a1.235 1.235 0 1 0 0-2.47 1.235 1.235 0 0 0 0 2.47ZM9.294 11.059a1.235 1.235 0 1 0 0-2.47 1.235 1.235 0 0 0 0 2.47Z"
        fill="#C4C4C4"
      />
      <path
        d="M13 25c6.627 0 12-5.373 12-12S19.627 1 13 1 1 6.373 1 13s5.373 12 12 12Z"
        stroke="#C4C4C4"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M18.366 16.953c-1.694.494-9.812.565-10.694.035"
        stroke="#C4C4C4"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
    </svg>
  );
}
export default SvgNeutralEmoji;
